import { Component, Input, OnChanges, OnInit, Output, SimpleChanges, EventEmitter } from '@angular/core';

import { TranslateService } from '@ngx-translate/core';

import { ConfirmationDialogAngularComponent } from 'rev-shared/ui/dialog/ConfirmationDialogAngular.Component';
import { DateUtil } from 'rev-shared/date/DateUtil';
import { DialogService } from 'rev-shared/ui/dialog/Dialog.Service';
import { TimezoneCodes } from 'rev-shared/date/TimezoneCodes';

import { IVideoPreposition } from './IVideoPreposition';
import { VideoPlaybackService } from './VideoPlayback.Service';

import styles from './preposition-dialog.module.less';

@Component({
	selector: 'preposition-dialog',
	templateUrl: './PrepositionDialog.Component.html'
})
export class PrepositionDialogComponent implements OnInit, OnChanges {
	@Input() public video: any;
	@Output() public onClose: EventEmitter<any> = new EventEmitter();

	public readonly TimezoneCodes = TimezoneCodes;
	public readonly styles = styles;

	public isSaving: boolean;
	public scheduleDateTime: Date;
	public scheduleTimezoneId: string;
	public today: Date;

	constructor(
		private VideoPlaybackSvc: VideoPlaybackService,
		private Dialog: DialogService,
		private TranslateService: TranslateService
	) { }

	public ngOnInit(): void {
		this.today = DateUtil.getToday();
	}

	public ngOnChanges(changes: SimpleChanges): void {
		if (changes.video && this.video && this.video.preposition) {
			const preposition: IVideoPreposition = this.video.preposition;

			this.scheduleDateTime = new Date(preposition.lastDateTime);
			this.scheduleTimezoneId = preposition.lastTimezoneId;
		}
	}

	public onCancel(): void {
		this.onClose.emit();
	}

	public onSave(): void {
		this.isSaving = true;

		this.VideoPlaybackSvc.prepositionVideo(this.video.id, this.scheduleDateTime, this.scheduleTimezoneId)
			.then(() => this.openDialog(
				'Media_Videos_Preposition_SaveConfirmationMessage',
				'Media_Videos_Preposition_SaveConfirmationTitle'
			).result)
			.then(() => this.onClose.emit())
			.catch(() => this.openDialog(
				'Media_Videos_Preposition_SaveFailedConfirmationMessage',
				'Media_Videos_Preposition_SaveFailedConfirmationTitle'
			))
			.finally(() => this.isSaving = false);
	}

	private openDialog(messageKey: string, titleKey: string, actionKey: string = 'Ok'): ConfirmationDialogAngularComponent {
		return this.Dialog.openConfirmationDialog(
			{
				message: this.TranslateService.instant(messageKey),
				title: this.TranslateService.instant(titleKey),
				actionText: this.TranslateService.instant(actionKey)
			}
		);
	}

}
